module.exports = "query adjustments($orderNumber:String!){order(orderNumber:$orderNumber){id adjustments{id amount isFixed source code}}}"